import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import axios from 'axios';
import GetApiwithoutPayload from 'services';

const initialState = {
    Projectdropdown: {},
    notification: {},
};

const ProjectDataSilce = createSlice({
    name: 'ProjectDropdown',
    initialState,
    reducers: {
        setProjectdropdown(state, action) {
            state.Projectdropdown = action.payload
        },
        setToast(state, action) {
            state.notification = action.payload
        }
    }
})

export const { setProjectdropdown, setToast } = ProjectDataSilce.actions;

export const ProjectDataDropdown = (accessToken, category) => async (dispatch) => {
    const url = `${process.env.REACT_APP_BASE_URL}/project/dropdown${category ? `?category=${encodeURIComponent(category)}` : ''}`;
    const data = await GetApiwithoutPayload(
        url,
        accessToken,
    )
        .then((res) => {
            console.log(res, 'API Responsesvdfv');
            const parsedData = JSON.parse(res);
            console.log(parsedData, 'API Response');
            dispatch(setProjectdropdown(parsedData))

        })
        .catch((err) => {
            console.log(err.response);
        })
}

const ProjectDropdownReducer = ProjectDataSilce.reducer;

export default ProjectDropdownReducer;